export default function TrustSection() {
  const features = [
    {
      icon: 'ri-time-line',
      title: 'Intervention Rapide',
      description: 'Disponible 7j/7 pour vos urgences',
      color: 'bg-blue-500',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Garantie Qualité',
      description: 'Réparations garanties 2 ans',
      color: 'bg-amber-400',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Prix Transparents',
      description: 'Devis détaillé et sans surprise',
      color: 'bg-blue-600',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Service Client',
      description: 'Équipe à votre écoute',
      color: 'bg-amber-500',
    },
  ];

  return (
    <section id="trust" className="bg-white py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Column - Image */}
          <div className="relative order-2 lg:order-1">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/09594199f543edf8e6303b639d7d7104.jpg"
                alt="Expert réparation fenêtres Lyon"
                className="w-full h-full object-cover object-top"
                loading="lazy"
                decoding="async"
                fetchpriority="low"
              />
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-6">
              <div className="flex items-center space-x-4">
                <div className="w-14 h-14 bg-gradient-to-br from-primary-500 to-primary-600 rounded-full flex items-center justify-center">
                  <i className="ri-tools-fill text-white text-2xl"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-sm">100%</div>
                  <div className="text-xs text-gray-600">Réparation</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="order-1 lg:order-2">
            {/* Intro Text */}
            <div className="mb-10">
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6 leading-tight">
                Nous Ne Vendons Pas de Fenêtres, Nous Les Réparons
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                <strong>Notre métier : réparer et entretenir vos fenêtres existantes.</strong> Nous ne posons pas de fenêtres neuves, nous ne sommes pas des vendeurs. Nous sommes des techniciens spécialisés dans la <a href="/remplacement-quincaillerie-fenetre-lyon" className="text-teal-600 hover:text-teal-700 underline font-medium">remise en état de menuiseries</a>.
              </p>
            </div>

            {/* Trust Points */}
            <div className="space-y-6">
              {/* Point 1 */}
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-search-eye-line text-primary-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">Diagnostic Honnête et Gratuit</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Un technicien se déplace pour diagnostiquer le problème. Si votre fenêtre est réparable (90% des cas), nous vous proposons une solution de réparation. Si elle ne l'est pas, nous vous le disons franchement et vous orientons vers un poseur. <a href="#contact" className="text-teal-600 hover:text-teal-700 underline font-medium">Demandez votre diagnostic</a>.
                  </p>
                </div>
              </div>

              {/* Point 2 */}
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-accent-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-money-euro-circle-line text-accent-700 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">Économies Garanties : 3 à 5x Moins Cher</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Réparer coûte 3 à 5 fois moins cher que remplacer. Exemple : une <a href="/remplacement-quincaillerie-fenetre-lyon" className="text-teal-600 hover:text-teal-700 underline font-medium">réparation de quincaillerie</a> coûte 150-300€, alors qu'une fenêtre neuve coûte 800-1500€. Consultez notre <a href="/blog/prix-reparation-fenetre-lyon-2025" className="text-teal-600 hover:text-teal-700 underline font-medium">guide des prix 2025</a>.
                  </p>
                </div>
              </div>

              {/* Point 3 */}
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-tools-fill text-primary-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">Réparation Immédiate : 85% le Jour Même</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Stock permanent de plus de 500 pièces détachées (poignées, crémones, gonds, joints...). Dans 85% des cas, nous réparons votre fenêtre le jour même, sans attendre de commande. Découvrez nos <a href="#services" className="text-teal-600 hover:text-teal-700 underline font-medium">services de réparation</a>.
                  </p>
                </div>
              </div>

              {/* Point 4 */}
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-accent-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-accent-700 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">Garantie 2 Ans sur Toutes Réparations</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    Toutes nos réparations sont garanties 2 ans pièces et main-d'œuvre. Nous utilisons exclusivement des pièces de qualité professionnelle (Ferco, Roto, Siegenia, GU). Voir nos <a href="#window-brands" className="text-teal-600 hover:text-teal-700 underline font-medium">marques partenaires</a>.
                  </p>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <div className="mt-10">
              <a
                href="#contact"
                className="inline-flex items-center space-x-3 bg-primary-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-primary-700 transition-all hover:shadow-xl hover:-translate-y-1 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-tools-line text-xl"></i>
                <span>Demander une Réparation</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
